
export default {

  name: 'Categories',

  inject: ['categoryData']

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/categories/Categories.js